 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import A780802197085 from '@/components/9780802197085'
 import A7808021970851 from '@/components/97808021970851'
 import A7808021970852 from '@/components/97808021970852'
 import A7808021970853 from '@/components/97808021970853'
 import A7808021970854 from '@/components/97808021970854'
 import A7808021970855 from '@/components/97808021970855'
 import A7808021970856 from '@/components/97808021970856'
 import A7808021970857 from '@/components/97808021970857'
 import A7808021970858 from '@/components/97808021970858'
 import A7808021970859 from '@/components/97808021970859'
 import A78080219708510 from '@/components/978080219708510'
 import A78080219708511 from '@/components/978080219708511'
 import A78080219708512 from '@/components/978080219708512'
 import A78080219708513 from '@/components/978080219708513'
 import A78080219708514 from '@/components/978080219708514'
 import A78080219708515 from '@/components/978080219708515'
 import A78080219708516 from '@/components/978080219708516'
 import A78080219708517 from '@/components/978080219708517'
 import A78080219708518 from '@/components/978080219708518'
 import A78080219708519 from '@/components/978080219708519'
 import A78080219708520 from '@/components/978080219708520'
 import A78080219708521 from '@/components/978080219708521'
 import A78080219708522 from '@/components/978080219708522'
 import A78080219708523 from '@/components/978080219708523'
 import A78080219708524 from '@/components/978080219708524'
 import A78080219708525 from '@/components/978080219708525'
 import A78080219708526 from '@/components/978080219708526'
 import A78080219708527 from '@/components/978080219708527'
 import A78080219708528 from '@/components/978080219708528'
 import A78080219708529 from '@/components/978080219708529'
 import A78080219708530 from '@/components/978080219708530'
 import A78080219708531 from '@/components/978080219708531'
 import A78080219708532 from '@/components/978080219708532'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9780802197085",
 			"name" : "9780802197085",
 			"component" : A780802197085
 		},
 		{
 			"path" : "/97808021970851",
 			"name" : "97808021970851",
 			"component" : A7808021970851
 		},
 		{
 			"path" : "/97808021970852",
 			"name" : "97808021970852",
 			"component" : A7808021970852
 		},
 		{
 			"path" : "/97808021970853",
 			"name" : "97808021970853",
 			"component" : A7808021970853
 		},
 		{
 			"path" : "/97808021970854",
 			"name" : "97808021970854",
 			"component" : A7808021970854
 		},
 		{
 			"path" : "/97808021970855",
 			"name" : "97808021970855",
 			"component" : A7808021970855
 		},
 		{
 			"path" : "/97808021970856",
 			"name" : "97808021970856",
 			"component" : A7808021970856
 		},
 		{
 			"path" : "/97808021970857",
 			"name" : "97808021970857",
 			"component" : A7808021970857
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js